import { P2 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  padding: 30px 20px;

  ${QUERIES.largeTabletAndUp} {
    padding: 40px;
  }

  display: flex;
  flex-direction: column;
  position: relative;

  * {
    text-align: center;
  }
`;

export const TextWrapper = styled.div`
  max-width: 640px;
`;

export const Image = styled.img`
  max-width: 100%;
  width: ${({ width }) => width || '736px'};
  border-radius: ${themeStyle.radiusMedium};
`;

export const Video = styled.video`
  max-width: 100%;
  width: ${({ width }) => width || '736px'};
  border-radius: ${themeStyle.radiusLarge};
  border: 1px solid ${themeStyle.varInkLight};
`;

export const Description = styled(P2)`
  white-space: pre-line;
`;
